import React from 'react';

function Medias() {

    return (
        <div>
            <div className='page'>
                <h1>Bonus</h1>
            </div>
        </div>
    );
}

export default Medias;